import './Modal.css';
import {useEffect} from "react";
import scrollToTop from "../../scripts/scroll-to-top";
import {useTranslation} from "react-i18next";
interface ModalProps {
    closeModal(): void
    text: string | null
}

function Modal(props: ModalProps) {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        scrollToTop();
    }, [])

    return (
        <div className='box-1 text-center'>
            <div className="title mb-3">{t("Modal Title")}</div>

            <div className='content mb-35'>{props.text}</div>

            <div className='d-flex justify-content-center'>
                <button
                    className="button-1 mr-6"
                    onClick={() => props.closeModal()}
                >
                    Back
                </button>

                <button
                    className="button-1"
                    onClick={() => props.closeModal()}
                >
                    Exit
                </button>
            </div>
        </div>
    )
}

export default Modal;